import { createSelector } from 'reselect';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import getModuleStateSelector from './getModuleStateSelector';

export const getIsCardOffersLoading = createSelector(
  getModuleStateSelector,
  (moduleState) => moduleState.get('isCardOffersLoading')
);

export const getHasCardOffersErrors = createSelector(
  getModuleStateSelector,
  (moduleState) => moduleState.get('hasCardOffersErrors')
);

export const getShowTravelCreditTab = createSelector(
  getModuleStateSelector,
  (moduleState) => moduleState.get('showTravelCreditTab')
);

export const getCardOffersPath = createSelector(
  getModuleStateSelector,
  (moduleState) => moduleState.get('cardOffersPath')
);

export const getAutomationCardOffersClassName = (hasHomePageCardOffers) => createSelector(
  getCardOffersPath,
  (cardOfferPath) => {
    if (cardOfferPath) {
      const snakeCaseCardOfferPath = cardOfferPath.split(/(?=[A-Z])/).join('-').toLowerCase();
      return `automation-card-offers-${snakeCaseCardOfferPath}`;
    }
    if (hasHomePageCardOffers) {
      return 'automation-card-offers-guest';
    }
    return null;
  }
);

export const generateCardOffersOneCmsPath = (locale, cardOffersPath) => `Internet/travel/consumer-travel/${locale.toLowerCase()}/homepagecardoffers/${cardOffersPath || 'guest'}.json`;
export const getEligibleCardOffersOneCmsPath = createSelector(
  getCardOffersPath,
  getActiveLocaleSelector,
  (cardOffersPath, locale) => generateCardOffersOneCmsPath(locale, cardOffersPath)
);
